import { BaseSlideControlClasses } from '../../common/components/variantSlider/variantSliderControls/baseSlideControlStyles';
import clsx from 'clsx';
import { SliderTypes } from '../enum/SliderTypes';

export const slickSliderUtilities = {
  getArrowSliderClass(className: string, styles: Record<BaseSlideControlClasses, string>, customStyles = ''): string {
    let baseArrowClass = styles.baseArrow;

    if (className.includes(SliderTypes.SLICK_PREV)) {
      baseArrowClass = clsx([baseArrowClass, styles.backArrow, customStyles]);
    }

    if (className.includes(SliderTypes.SLICK_NEXT)) {
      baseArrowClass = clsx([baseArrowClass, styles.forwardArrow, customStyles]);
    }

    if (className.includes(SliderTypes.SLICK_DISABLED)) {
      baseArrowClass = clsx([baseArrowClass, styles.disabledArrow]);
    }

    return baseArrowClass;
  },
};
